import React, { useState, useEffect } from "react";
import {
  Box,
  Button,
  TextField,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Snackbar,
  Alert,
  Typography,
} from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import axios from "axios";
import Header from "components/Header";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
const Blog = () => {
  const apiUrl = process.env.REACT_APP_API_URL;
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [openModal, setOpenModal] = useState(false);
  const [imagePath, setImagePath] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [currentBlog, setCurrentBlog] = useState(null);
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [tag, setTag] = useState("");
  const [image, setImage] = useState("");

  useEffect(() => {
    fetchBlogs();
  }, []);

  const fetchBlogs = async () => {
    try {
      const response = await axios.get(`${apiUrl}/blog/getblog`); // Adjust this to your API endpoint
      setData(response.data);
      setIsLoading(false);
    } catch (error) {
      console.error("Error fetching data:", error);
      setIsLoading(false);
    }
  };

  const handleOpenModal = (blog) => {
    if (blog) {
      setCurrentBlog(blog);
      setTitle(blog.title);
      setDescription(blog.description);
      setTag(blog.tag);
      setImagePath(blog.image);
    } else {
      setCurrentBlog(null);
      setTitle("");
      setDescription("");
      setTag("");
      setImagePath("");
    }
    setOpenModal(true);
  };

  const handleCloseModal = () => {
    setOpenModal(false);
    setCurrentBlog(null);
  };

  const handleSnackbarClose = () => {
    setSnackbarOpen(false);
  };
  const handleFileChangeProcess = (event) => {
    const selectedImage = event.target.files[0];
    if (selectedImage) {
      handleImageUpload(selectedImage, setImagePath); // Automatically upload the image
    }
  };
  const handleImageUpload = async (file, setImagePath) => {
    const formData = new FormData();
    formData.append("image", file);

    try {
      const response = await axios.post(`${apiUrl}/upload`, formData);
      console.log("this is image path>>:", response.data.filePath);
      // setImagePath(response.data.filePath); // Assuming the backend returns the image path
      setImagePath(response.data.url);
    } catch (error) {
      console.error("Error uploading image:", error);
      setErrorMessage("Error uploading image.");
      setSnackbarOpen(true);
    }
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (!title || !description || !tag || !imagePath) {
      setErrorMessage("Title,number and image are required.");
      setSnackbarOpen(true);
      return;
    }
    const postData = {
      title,
      description,
      tag,
      image: imagePath,
    };

    try {
      const response = await axios.post(`${apiUrl}/blog/createblog`, postData);
      setData((prevData) => [...prevData, response.data]);
      handleCloseModal();
    } catch (error) {
      console.error("Error submitting form:", error);
    }
  };

  const handleUpdate = async (event) => {
    event.preventDefault();
    if (!title || !description || !tag || !imagePath) {
      setErrorMessage("Title,number and image are required.");
      setSnackbarOpen(true);
      return;
    }
    const updateData = {
      title,
      description,
      tag,
      image: imagePath,
    };

    try {
      const response = await axios.put(
        `${apiUrl}/blog/updateblog/${currentBlog._id}`,
        updateData,
      );
      setData((prevData) =>
        prevData.map((item) =>
          item._id === currentBlog._id ? response.data : item,
        ),
      );
      handleCloseModal();
    } catch (error) {
      console.error("Error updating blog:", error);
    }
  };

  const handleDelete = async (id) => {
    try {
      await axios.delete(`${apiUrl}/blog/deleteblog/${id}`);
      setData((prevData) => prevData.filter((item) => item._id !== id));
    } catch (error) {
      console.error("Error deleting blog:", error);
    }
  };

  const columns = [
    { field: "title", headerName: "Title", flex: 0.5 },
    { field: "description", headerName: "Description", flex: 0.5 },
    { field: "tag", headerName: "Tag", flex: 0.5 },
    {
      field: "image",
      headerName: "Image",
      flex: 0.5,
      renderCell: (params) => (
        // <img src={`${apiUrl}/${params.row.image}`} alt={params.row.title} width="50" height="50" />
        <img
          src={params.row.image}
          alt={params.row.title}
          width="50"
          height="50"
        />
      ),
    },
    {
      field: "actions",
      headerName: "Actions",
      flex: 0.5,
      renderCell: (params) => (
        <>
          <Button
            variant="contained"
            color="primary"
            size="small"
            onClick={() => handleOpenModal(params.row)}
          >
            Update
          </Button>
          <Button
            variant="contained"
            color="secondary"
            size="small"
            onClick={() => handleDelete(params.row._id)}
          >
            Delete
          </Button>
        </>
      ),
    },
  ];

  return (
    <Box m="1.5rem 2.5rem">
      <Header
        title="EXPLORE BLOGS AND NEWS"
        subtitle="List of Blogs and News"
      />
      <Button
        variant="contained"
        color="primary"
        onClick={() => handleOpenModal(null)}
      >
        Add New Blog
      </Button>

      <Dialog open={openModal} onClose={handleCloseModal}>
        <DialogTitle>
          {currentBlog ? "Update Blog" : "Add New Blog"}
        </DialogTitle>
        <DialogContent>
          <TextField
            autoFocus
            margin="dense"
            label="Title"
            type="text"
            fullWidth
            variant="outlined"
            value={title}
            onChange={(e) => setTitle(e.target.value)}
          />
          <TextField
            margin="dense"
            label="Description"
            type="text"
            fullWidth
            variant="outlined"
            value={description}
            onChange={(e) => setDescription(e.target.value)}
          />
          <TextField
            margin="dense"
            label="Tag"
            type="text"
            fullWidth
            variant="outlined"
            value={tag}
            onChange={(e) => setTag(e.target.value)}
          />
          <Button
            variant="outlined"
            component="label"
            startIcon={<CloudUploadIcon />}
          >
            Upload Image
            <input
              type="file"
              hidden
              onChange={handleFileChangeProcess} // Store the file object instead
            />
          </Button>
          {imagePath && (
            <Typography variant="body2" sx={{ mt: 1 }}>
              {/* <img src={`${apiUrl}/${imagePath}`} alt="image" width="50" height="50" /> */}
              <img src={imagePath} alt="image" width="50" height="50" />
            </Typography>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseModal} color="primary">
            Cancel
          </Button>
          <Button
            onClick={currentBlog ? handleUpdate : handleSubmit}
            color="primary"
          >
            {currentBlog ? "Update" : "Add"}
          </Button>
        </DialogActions>
      </Dialog>

      <Box mt="40px" height="75vh">
        <DataGrid
          loading={isLoading}
          getRowId={(row) => row._id}
          rows={data || []}
          columns={columns}
          pageSize={5}
        />
      </Box>
      <Snackbar
        open={snackbarOpen}
        autoHideDuration={6000}
        onClose={handleSnackbarClose}
      >
        <Alert onClose={handleSnackbarClose} severity="error">
          {errorMessage}
        </Alert>
      </Snackbar>
    </Box>
  );
};

export default Blog;
